export default __webpack_public_path__ + "static/media/sangrias.f7982706.webp";